import { splitPhoneNum } from '~components/PartnerZipLeadComboForm/formatPhone';

type EmployerLeadError = {
    type: string;
    message: string;
    errorType: null;
};

type EmployerLeadResponseData = {
    leadId?: number;
    error?: EmployerLeadError;
};

const encodedDate = (date: Date): string => {
    // Extracting the date components
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth is 0-indexed
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    // Formatting the date string
    // Manually replacing ":" with "%3A" for the time part
    const formattedDate = `${day}-${month}-${year}+${hours}%3A${minutes}%3A${seconds}`;

    return formattedDate;
};

export const createLead = async ({
    firstName,
    lastName,
    phone,
    email,
    companyName,
    zip,
    employees,
    allianceId,
    leadType,
    fixedAllianceId,
    leadSource = 'TRAD',
    tcpaTemplate = '',
}: EMPLeadRequestArgs) => {
    const now = new Date();
    const phoneParts = splitPhoneNum(phone);
    const sentToDialer = leadType ? (leadType === 'Roadshow' ? false : true) : true;
    // YODA-18843 quick fix to support dynamic alliance ids
    const finalAllianceId = allianceId;

    return await fetch(`${process.env.GATSBY_SMB_URL}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Cookie: `createdTime=${encodedDate(now)}; ehiVisitorId=326D30F280B25F2F9ACB35D51656EB43`,
        },
        body: JSON.stringify({
            allianceId: finalAllianceId,
            allianceSid: null,
            alliancePid: null,
            allianceCampaign: null,
            creationMethod: leadSource,
            eeSize: employees,
            zipCode: zip,
            contactFirstName: firstName,
            contactLastName: lastName,
            email: email,
            companyName: companyName || '',
            areaNum: phoneParts?.areaNum,
            phone: phoneParts?.phoneNum,
            sentToDialer: sentToDialer,
            tcpaTemplate,
        }),
    }).then((res): Promise<EmployerLeadResponseData> => res.json());
};
